import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import { useTranslation } from "react-i18next";

const TechBadge = ({ name }) => (
  <span className="px-2 py-1 text-sm text-blue-800 bg-blue-100 rounded-md dark:bg-blue-900 dark:text-blue-100">
    {name}
  </span>
);

const FooterSection = () => {
  const { t } = useTranslation();

  return (
    <footer className="py-4 text-white bg-gradient-to-r from-blue-600 to-blue-800">
      <div className="flex flex-col justify-between px-4 mx-auto max-w-6xl md:flex-row">
        <div className="flex flex-col mb-4 md:mb-0">
          <p className="mb-2">
            {t("designed and developed by john linthicum © sep. 2024")}
          </p>
          <div className="flex items-center">
            <EmailIcon className="mr-2" />
            <a
              href="mailto:johnlinthicum1@gmail.com"
              className="text-white hover:underline"
            >
              johnlinthicum1@gmail.com
            </a>
          </div>
        </div>
        <div className="flex flex-col items-start md:items-end">
          <p className="mb-2">{t("created with")}</p>
          <div className="flex gap-2">
            <TechBadge name="React" />
            <TechBadge name="Tailwind" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
